"use strict";
require.context("../../images", true);
import "src/decidim/focasos_autosave";
import "src/decidim/focasos_validaciones";
import "src/decidim/focasos_web";
import "src/decidim/focasos_notificaciones";
import "src/decidim/focasos_escuchar";
